import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import minecraftUrls from "../../configs/mine_craft/minecraftUrls";
import { MainSkinInterface } from "../../store/mine_craft/mainSkinsSlice";

const processStrategy = (value: any) => {
  return {
    ...value,
    url: minecraftUrls.mainSkinPath(value.id),
    thumbnail_url: minecraftUrls.remoteUrl(value.thumbnail_url),
    mcpack_url: minecraftUrls.remoteUrl(value.mcpack_url),
    mcpack_second_url: minecraftUrls.remoteUrl(value.mcpack_second_url)
  };
}

const mainSkinsEntity = new schema.Entity(
  'main_skins',
  {},
  {
    processStrategy
  }
);

const mainSkinEntity = new schema.Entity(
  'main_skin',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { main_skin: MainSkinInterface }>(response.data.main_skin, mainSkinEntity);
  return normalized.entities;
}

export const fetchMainSkins = createAsyncThunk(
  'mainSkins/fetchMainSkins',
  async (params: object = {}) => {
    const response    = await mineCraftApi.get(`/onesky/main_skins`, { params })
    const normalized  = normalize<any, { main_skins: { [key: string]: MainSkinInterface } }>(response.data.main_skins, [mainSkinsEntity]);

    return {
      main_skins: normalized.entities?.main_skins || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchMainSkin = createAsyncThunk(
  'mainSkins/fetchMainSkin',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/main_skins/${id}`);
    return normalizeInstance(response);
  }
);

export const createMainSkin = createAsyncThunk(
  'mainSkins/createMainSkin',
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(`/onesky/main_skins`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateMainSkin = createAsyncThunk(
  'mainSkins/updateMainSkin',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/main_skins/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyMainSkin = createAsyncThunk(
  'mainSkins/destroyMainSkin',
  async (id: number) => {
    const response = await mineCraftApi.delete(`/onesky/main_skins/${id}`);
    return response.data;
  }
);
